export const SET_PRINCIPAL_ID = 'AUTH::SET_PRINCIPAL_ID'
export const SET_ADDRESS = 'AUTH::SET_ADDRESS'
export const SET_IDENTITY = 'AUTH::SET_IDENTITY'
export const SET_USER_CANISTER_ID = 'AUTH::SET_USER_CANISTER_ID'
export const SET_LOADER = 'AUTH:: SET_LOADER'
export const RESET_STATE = 'AUTH:: RESET_STATE'
export const SET_WALLET = 'AUTH::SET_WALLET'
